export const IconProp = {
    width: "20px",
    height: "20px",
    color: "white",
    className: "",
    backgroundColor: "black"
}